import React from 'react'

import './Loading.scss'

interface IProps {
  className?: string
}

class Loading extends React.Component<IProps> {
  public render(): JSX.Element {
    return (
      <div className={`${this.props.className} LoadingWrapper container-fluid`}>
        <div className="Loading row no-gutter">
          <div className="col">
            <h1 className="pb-3">Canadian Election Explorer 2019</h1>
            <h2>Loading&hellip;</h2>
            <div className="Spinner fa-3x">
              <i className="fas fa-circle-notch fa-spin" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Loading
